import { useCallback, useContext, useMemo } from 'react'
import FlightSearchWidgetStateContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateContext'
import FlightSearchWidgetDispatchContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetDispatchContext'
import { FlightSearchWidgetActions } from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateReducer'
import { addDays } from 'lib/dateUtils'
import { FlightsFareTypes } from 'constants/flight'

const useDateFlightSearchProps = () => {
  const { checkinDate, checkoutDate, departureAirport, arrivalAirport, fareType } = useContext(FlightSearchWidgetStateContext)
  const globalSearchDispatch = useContext(FlightSearchWidgetDispatchContext)
  const hasDates = !!(checkinDate && checkoutDate)

  const handleDatesChanged = useCallback(
    (dates: { startDate: moment.Moment; endDate: moment.Moment }) => {
      globalSearchDispatch({ type: FlightSearchWidgetActions.SET_CHECKIN_DATE, date: dates.startDate })
      globalSearchDispatch({ type: FlightSearchWidgetActions.SET_CHECKOUT_DATE, date: dates.endDate })
    },
    [globalSearchDispatch],
  )

  const confirmButtonDisabled = useMemo(() => {
    if (fareType.value === FlightsFareTypes.ONE_WAY) {
      return !checkinDate
    }

    return !!checkinDate && !checkoutDate
  }, [checkinDate, checkoutDate, fareType])

  const minDate = addDays(new Date(), 2)
  const maxDate = addDays(new Date(), 330)

  return ({
    checkinDate,
    checkoutDate,
    confirmButtonDisabled,
    handleDatesChanged,
    hasDates,
    minDate,
    maxDate,
    departureAirport,
    arrivalAirport,
    fareType,
  })
}

export default useDateFlightSearchProps
